module.exports = __webpack_public_path__ + "static/sport/left-bg.2b16724.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/left-bg.png
// module id = QWUU
// module chunks = 0